import React from 'react';
import { List, Segment } from 'semantic-ui-react';
import { FormattedMessage, injectIntl } from 'react-intl';

const Footer = ({ intl }) => {
    const currentYear = new Date().getFullYear();

    return (
        <Segment role="contentinfo" padded id="footer">
            <div className="footerTop">

                <div className='logoWhiteDiv'>
                    <img src='../Logo_White.svg' alt='Logo White' className='logoWhite' />
                </div>

                <div>
                    <List className="footerList">
                        <div role="listitem" className="item footerName">
                            <p className="item">
                                <FormattedMessage
                                    id="Footer-Name"
                                    defaultMessage="Loosli Fit"
                                />
                            </p>
                        </div>
                        <div role="listitem" className="item">
                            <p className="item">
                                <FormattedMessage
                                    id="Footer-Adress"
                                    defaultMessage="Alleestrasse 10A"
                                />
                            </p>
                        </div>
                        <div role="listitem" className="item">
                            <p className="item">
                                <FormattedMessage
                                    id='Footer-Plz-Ort'
                                    defaultMessage="3550, Langnau i.E."
                                />
                            </p>
                        </div>
                    </List>
                </div>

                <div>
                    <List className="footerList">
                        <div role="listitem" className="item">
                            <i className="ri-phone-line"></i>
                            <a className="item" href="tel:+41792932042">
                                <FormattedMessage
                                    id='Footer-Telefon'
                                    defaultMessage="079 293 20 42"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <i className="ri-mail-line"></i>
                            <a className="item" href="mailto:info@looslifit.ch">
                                <FormattedMessage
                                    id='Footer-Email'
                                    defaultMessage="info@looslifit.ch"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item" style={{ marginTop: "15px" }}>
                            <a className="item" href="https://www.facebook.com/Looslifit" target='_blank'>
                                <i className='ri-facebook-circle-fill' style={{ fontSize: "25pt" }}></i>
                            </a>
                            <a className="item" href="https://www.instagram.com/looslifit" target='_blank'>
                                <i className='ri-instagram-line' style={{ fontSize: "25pt" }}></i>
                            </a>
                        </div>
                    </List>
                </div>
                <div>
                    <List className="footerList">
                        <div className='logoVPT'>
                            <p className="item">Mitglied</p>
                            <a href='https://v-p-t.ch/v-p-t-neumitglied-hans-loosli/' target='_blank'><img src='../logo_vpt.png' alt='Logo VPT' className='logoVPT' /></a>
                        </div>
                        <div className='logoEMR'>
                            <a href='https://emr.ch/therapeut/hans.loosli/' target='_blank'><img src='../logo_emr.png' alt='Logo EMR' className='logoEMR' /></a>
                        </div>
                    </List>
                </div>
            </div>
            <hr />
            <div className='footerBottom'>
                <div>
                    <List className="footerList">
                        <div role="listitem" className="item">
                            <a className="item" href="./impressum">
                                <FormattedMessage
                                    id='Footer-Imprint'
                                    defaultMessage="Impressum"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <a className="item" href="./datenschutz">
                                <FormattedMessage
                                    id='Footer-Privacy'
                                    defaultMessage="Datenschutzerklärung"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <a className="item" href="./agb">
                                <FormattedMessage
                                    id='Footer-AGB'
                                    defaultMessage="AGB"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <a className="item" href="./hausordnung">
                                <FormattedMessage
                                    id='Footer-Hausordnung'
                                    defaultMessage="Hausordnung"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <i className="ri-copyright-line"></i>
                            {currentYear}&nbsp;
                            <FormattedMessage
                                id='Footer-Copyright'
                                defaultMessage="Loosli Fit"
                            />
                        </div>
                    </List>
                </div>
            </div>
        </Segment>
    );
};

export default injectIntl(Footer);